import React from 'react';

const Table = (props: any) => {
    return (
        <div className='table-wrapper'>
            <table>
                <thead>
                    <tr>
                        {props.head.map((item: any, index: number) => <th style={{minWidth: `${Array.isArray(item) ? item[1] : ''}`}} key={index}>{Array.isArray(item) ? item[0] : item}</th>)}
                    </tr>
                </thead>
                <tbody>
                    {props.body.map((row: any, index: number) => (
                        <tr key={index}>
                            {row.map((cell: any, i: number) => <td key={i}>{cell}</td>)}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Table;
